import { interaction } from "pixi.js";

/*
    Popper object is used for elements hovering the game.
    When using, it is mandatory to call the open() and close() methods to maintain correct game state.
    The removeFromCanvas method should dispose of the popper class, without managing state.
*/ 
export class ClickAwayListener{
    
    private stage : PIXI.DisplayObject;
    private object: PIXI.DisplayObject;
    private callback: Function;
    private interactCallback : (event: interaction.InteractionEvent) => void;
    private isActive: boolean;
    // private id: number;
	constructor(stage: PIXI.DisplayObject, object: PIXI.DisplayObject, fn : Function) 
	{
        this.isActive = false;
		this.stage=stage;
        this.object=object;
        this.callback = fn;
        this.interactCallback = this.interact.bind(this);
        // this.id = Date.now();
	}

    public activate(): void{
        if(!this.isActive){
            this.isActive = true;
        this.stage.interactive = true;
        setTimeout(()=>{this.stage.addListener("pointertap",this.interactCallback)},1);
        // console.log("activate" +  this.id);
    }
    }

    public interact(event: interaction.InteractionEvent):void{
        let boundsObject = this.object.getBounds();
     
        // console.log("interact" +  this.id)
        if(!boundsObject.contains(event.data.global.x,event.data.global.y)){
        this.desactivate()
        this.callback();
     }   
    }

    public desactivate(): void {
        if(this.isActive){
            this.isActive = false;
        this.stage.interactive =false;
        this.stage.removeListener("pointertap",this.interactCallback);
        // console.log("deactivate"+  this.id)
    }
    }
}

